import React from "react";
import { FacebookShareButton, FacebookIcon } from "react-share";

// material ui
import Box from "@mui/material/Box";

const ShareButton = () => (
  <Box
    style={{
      marginLeft: "0.5rem",
      padding: "5px 15px",
      border: "1px solid currentColor",
      display: "flex",
      borderRadius: "4px",
    }}
  >
    <FacebookShareButton url={document.location.href}>
      <FacebookIcon size={32} round />
    </FacebookShareButton>
  </Box>
);
export default ShareButton;
